import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

export default {
  id: 'Counties',
  type: 'WMS',
  url: 'https://www.wfas.net/cgi-bin/mapserv?service=wms',
  title: {
    'en-US': 'Counties',
    'pt-BR': 'Condados',
    'es-ES': 'Condados',
    'fr-FR': 'Comtés'
  },
  zindex: 1, // TODO: CHECK
  active: false,
  activeTarget: 'visibility',
  customProperties: { group: 'reference' },
  legend: {
    title: 'n/a' // TODO: CHECK
  },
  sublayers: [
    {
      id: 'counties',
      visible: true,
      layers: 'counties',
      legend: {
        title: {
          'en-US': 'Counties',
          'pt-BR': 'Condados',
          'es-ES': 'Condados',
          'fr-FR': 'Comtés'
        },
        items: [
          {
            text: {
              'en-US': 'Counties',
              'pt-BR': 'Condados',
              'es-ES': 'Condados',
              'fr-FR': 'Comtés'
            },
            color: '#000000',
            icon: 'mdi-minus'
          }
        ]
      }
    }
  ],
  icon: 'mdi-barley' // TODO: CHECK
} as LayerRaw
